/** @format */
import { RedirectToResult, Transition } from '@uirouter/core';
import { firstValueFrom } from 'rxjs';
import { FeedbackFeatureToggleService } from './feedback-feature-toggle.service';

export type RedirectTo = (transition: Transition) => Promise<RedirectToResult>;

/**
 * Create UIRouter redirect function that redirects to given state if feedback feature toggle is not enabled.
 */
export const feedbackFeatureToggleRedirect =
    (redirectTo: string): RedirectTo =>
    async transition => {
        const feedbackEnabled = await transition.injector().get(FeedbackFeatureToggleService).getFeedbackEnabled().pipe(firstValueFrom);
        return !feedbackEnabled && redirectTo;
    };
